import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import ProductSelectionFiltersComponent from './ProductSelectionFiltersComponent';
import AddFinancialProductModal from './FinancialProductAdd/AddFinancialProductModal';
import ProductList from './ProductList';
import { withTranslation } from 'react-i18next';
import { Button } from '@totalsoft/rocket-ui';
import { RightsContext } from 'providers/RightsContext';
import WrappedFakeText from 'components/common/WrappedFakeText';

export const ProductSelectionCard = ({
  flags,
  filterData,
  documentId,
  siteId,
  t,
  onPushFilterValues,
  onFilterChange,
  onSelectProduct,
  products,
  areGraceRatesVisible,
  areGuaranteeRatesVisible,
  onChangeFinancialProductAddModal,
  showFinancialProductAddModal,
  numberOfProducts,
  productsViewMode,
  setProductsViewMode,
  maximumNumberOfProducts,
  orderObject,
  orderOptions,
  onOrderChange,
  processing,
  contractTypeNames,
  onContractTypeLinkClick,
  showFilterOfferContracts,
  setFavoriteProduct,
  setDeleteProduct,
  exportSimulationButtonVisible,
  onPropertyChange
}) => {
  const productsGenerating = flags.computingSimulations && (!products || products.length === 0);

  const { financialProductWrite, readOnlyFull } = useContext(RightsContext);

  return flags.productDataLoading ? (
    <WrappedFakeText px={2} my={1} onPaper />
  ) : flags.productDataLoaded ? (
    <>
      {filterData && filterData.document && (
        <ProductSelectionFiltersComponent
          filterData={filterData}
          numberOfProducts={numberOfProducts}
          onFilterChange={onFilterChange}
          onPushFilterValues={onPushFilterValues}
          flags={flags}
          setProductsViewMode={setProductsViewMode}
          productsViewMode={productsViewMode}
          orderObject={orderObject}
          orderOptions={orderOptions}
          onOrderChange={onOrderChange}
          processing={processing}
          contractTypeNames={contractTypeNames}
          onContractTypeLinkClick={onContractTypeLinkClick}
          showFilterOfferContracts={showFilterOfferContracts}
          financialProductWrite={financialProductWrite}
          readOnlyFull={readOnlyFull}
          onPropertyChange={onPropertyChange}
        />
      )}
      {productsGenerating ? (
        <WrappedFakeText px={2} />
      ) : (
        <>
          <ProductList
            products={products}
            productsViewMode={productsViewMode}
            onSelect={onSelectProduct}
            selectingProductId={flags.selectingProductId}
            computingSimulations={flags.computingSimulations}
            areGraceRatesVisible={areGraceRatesVisible}
            areGuaranteeRatesVisible={areGuaranteeRatesVisible}
            processing={processing}
            setFavoriteProduct={setFavoriteProduct}
            setDeleteProduct={setDeleteProduct}
            exportSimulationButtonVisible={exportSimulationButtonVisible}
          />
          {showFinancialProductAddModal && (
            <AddFinancialProductModal
              showFinancialProductAddModal={showFinancialProductAddModal}
              onModalClose={onChangeFinancialProductAddModal}
              documentId={documentId}
              siteId={siteId}
            />
          )}
          <Grid container justifyContent='end' mt={3}>
            <Button
              id={'product_addBtn'}
              onClick={onChangeFinancialProductAddModal}
              disabled={!(numberOfProducts.total < maximumNumberOfProducts) || processing || readOnlyFull || !financialProductWrite}
            >
              {t('OfferEdit.FinancialProducts.AddNewProduct')}
            </Button>
          </Grid>
        </>
      )}
    </>
  ) : (
    ''
  );
};

ProductSelectionCard.propTypes = {
  flags: PropTypes.object.isRequired,
  filterData: PropTypes.object,
  documentId: PropTypes.number,
  siteId: PropTypes.number,
  t: PropTypes.func.isRequired,
  onChangeFinancialProductAddModal: PropTypes.func.isRequired,
  showFinancialProductAddModal: PropTypes.bool.isRequired,
  products: PropTypes.array.isRequired,
  onPushFilterValues: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onSelectProduct: PropTypes.func.isRequired,
  areGraceRatesVisible: PropTypes.bool.isRequired,
  areGuaranteeRatesVisible: PropTypes.bool.isRequired,
  numberOfProducts: PropTypes.object.isRequired,
  productsViewMode: PropTypes.number.isRequired,
  setProductsViewMode: PropTypes.func.isRequired,
  orderOptions: PropTypes.array.isRequired,
  orderObject: PropTypes.object.isRequired,
  onOrderChange: PropTypes.func.isRequired,
  processing: PropTypes.bool,
  maximumNumberOfProducts: PropTypes.number,
  contractTypeNames: PropTypes.string,
  onContractTypeLinkClick: PropTypes.func.isRequired,
  setFavoriteProduct: PropTypes.func.isRequired,
  setDeleteProduct: PropTypes.func.isRequired,
  showFilterOfferContracts: PropTypes.bool,
  financialProductWrite: PropTypes.bool,
  readOnlyFull: PropTypes.bool,
  exportSimulationButtonVisible: PropTypes.bool,
  onPropertyChange: PropTypes.func.isRequired
};

export default withTranslation()(ProductSelectionCard);
